var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "solutions-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Solutions")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#digital-engagement",
            text: "Digital engagement",
            caption:
              "Leverage our data, network and partnerships across Africa to digitally connect with corporate partners",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#digital-engagement")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#custom-research",
            text: "Custom research",
            caption:
              "Call on our pan-African corporate database and in-country analyst network to conduct market analysis",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#custom-research")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#compliance-support",
            text: "Compliance support",
            caption:
              "Benefit from our access to corporate registries to gather company records at industry-leading turnaround times",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#compliance-support")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Publications")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/insights/market-insights",
            text: "Market Insights",
            caption:
              "Access Asoko's proprietary insights on Africa's private sector",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/insights/market-insights")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/insights/developments",
            text: "Corporate news",
            caption:
              "View the latest news and updates on Asoko’s partnerships, events and opportunities",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/insights/developments")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/#subscribe",
            text: "Newsletter",
            caption:
              "Sign up for for free weekly updates on Africa's leading business stories and Asoko updates",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/#subscribe")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block user-block" },
      [
        _c("h6", [_vm._v("You and Asoko")]),
        _vm._v(" "),
        _c("user-menu-item", {
          attrs: {
            path: "/projects",
            text: "My projects",
            caption:
              "Start and manage your custom research projects with Asoko's in-country analyst teams",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/projects")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }